export const REDUCER_NAME = "SELECTED_ORGANISATION";
